import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import DOMPurify from 'dompurify';
import styles from './ProductModal.module.css';
import { buildWhatsAppOrderUrl } from '../utils/whatsapp';

const ProductModal = ({ product, onClose, onAddToCart, loading }) => {
    const [selectedPhotoIndex, setSelectedPhotoIndex] = useState(0);
    const navigate = useNavigate();

    if (!product) return null;

    // Use photo_url fields from product for photos array
    const photos = [
        product.photo_url,
        product.photo_url2,
        product.photo_url3,
        product.photo_url4,
        product.photo_url5,
        product.photo_url6,
        product.photo_url7
    ].filter(Boolean); // filter out undefined or null

    if (loading) {
        return (
            <div className={styles.modalOverlay} onClick={onClose}>
                <div className={styles.modalContent} onClick={e => e.stopPropagation()}>
                    Loading...
                </div>
            </div>
        );
    }

    return (
        <div className={styles.modalOverlay} onClick={onClose}>
            <div className={styles.modalContent} onClick={e => e.stopPropagation()}>
                <button 
                    onClick={onClose} 
                    className={styles.closeButton} 
                    aria-label="Close modal"
                >
                    &times;
                </button>

                <div className={styles.buttonContainer}>
                    <button
                        onClick={(e) => {
                            e.stopPropagation();
                            onAddToCart(product);
                        }}
                        className={styles.addToCartButton}
                    >
                        Add to Cart
                    </button>

                    <button
                        onClick={(e) => {
                            e.stopPropagation();
                            window.open(buildWhatsAppOrderUrl(product), '_blank', 'noopener,noreferrer');
                        }}
                        className={`${styles.addToCartButton} ${styles.whatsappButton}`}
                    >
                        <i className="fa fa-whatsapp" aria-hidden="true"></i> WhatsApp
                    </button>

                    <button
                        onClick={(e) => {
                            e.stopPropagation();
                            navigate(`/myproduct/${product.item_id}`);
                        }}
                        className={styles.productPageButton}
                    >
                        Product Page
                    </button>
                </div>

                <div className={styles.productInfo}>
                    {product.category} / {product.brand}  
                </div>

                <h2 className={styles.productName}>{product.item_name}</h2>
                               <h6 className={styles.productInfo}>{product.item_condition}</h6>
                {product.the_size && (
                    <div className={styles.productInfo}>Size: {product.the_size}</div>
                )}
                {product.dimen && (
                    <div className={styles.productInfo}>Dimensions: {product.dimen}</div>
                )}


                <div
                    className={styles.productDescription}
                    dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(product.item_description || '') }}
                />

                <div className={styles.photoGallery}>
                    <img 
                        src={photos[selectedPhotoIndex]} 
                        alt={`${product.item_name} - ${selectedPhotoIndex + 1}`} 
                        className={styles.mainPhoto}
                    />
                    <div className={styles.thumbnailContainer}>
                        {photos.map((photo, index) => (
                            <img
                                key={index}
                                src={photo}
                                alt={`${product.item_name} thumbnail ${index + 1}`}
                                className={`${styles.thumbnail} ${selectedPhotoIndex === index ? styles.thumbnailSelected : ''}`}
                                onClick={() => setSelectedPhotoIndex(index)}
                                tabIndex={0}
                                onKeyPress={(e) => { if (e.key === 'Enter') setSelectedPhotoIndex(index); }}
                            />
                        ))}
                    </div>
                </div>

                <div
                    className={styles.productFeature}
                    dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(product.item_feature || '') }}
                />
            </div>
        </div>
    );
};

export default ProductModal;
